<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'NavBar',
})
</script>
<template>
  <div>
    <NavBar
      :title="title"
      :fixed="fixed"
      :left-text="leftText"
      :left-arrow="leftArrow"
      :border="false"
      :safe-area-inset-top="true"
      z-index="500"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #title>
        <span v-if="showTitle">
          {{ title }}
        </span>
        <slot v-else name="title"> </slot>
      </template>
      <template #right>
        <slot name="right"> </slot>
      </template>
    </NavBar>
  </div>
</template>
<script setup lang="ts" name="NavBar">
import { NavBar } from 'vant'
import { useRouter } from 'vue-router'
// import { destroyH5 } from '@/utils/nativeAPI'
interface IProps {
  title?: string
  leftText?: string
  leftArrow?: boolean
  fixed?: boolean
  selfClick?: boolean
  showTitle?: boolean
}
const router = useRouter()
// const isApp = router.currentRoute.value.meta?.isApp
const props = withDefaults(defineProps<IProps>(), {
  title: '',
  leftText: '',
  leftArrow: true,
  fixed: false,
  selfClick: false,
  showTitle: true
})

const emit = defineEmits<{
  (event: 'goBack'): void
  (event: 'rightClick'): void
}>()

const onClickLeft = () => {
  if (!props.selfClick) {
    router.go(-1)
  } else {
    emit('goBack')
  }
}
const onClickRight = () => {
  emit('rightClick')
}
</script>

<style scoped lang="less">
:deep(.van-nav-bar__content) {
  height: 45px;
  background-color: #fff;
}
:deep(.van-nav-bar__title) {
  color: #171921;
  font-weight: 500;
  font-size: 18px;
}
.van-nav-bar :deep(.van-icon) {
  font-size: 20px;
  color: #171921;
}
:deep(.van-nav-bar__text) {
  color: #171921;
}
</style>
